import {useContext} from 'react';
import RegistriesContext from 'src/internal/contexts/RegistriesContext';
import XContext from 'src/internal/contexts/XContext';
import {defaultFlag} from 'src/internal/defaults';
import useX from 'src/internal/hooks/useX';

import type {Flag, InnerFlags} from 'src/types';

/**
 * Returns the value of a given flag, which can be `true` or `false`. A flag
 * that is not registered in the access configuration will return `false`.
 *
 * Besides flag names defined in the configuration, you can also pass `'true'`
 * or `'false'` to return `true` or `false` respectively. This is useful for
 * making the hook conditional.
 *
 * @see https://sail.stripe.me/apis/access/useFlag
 */
export default function useFlag<TName extends Flag>(
  /** Flag name (registered in `SailAccessFlags`). */
  name: TName,
): InnerFlags[TName] {
  const flags = useContext(XContext).flags;
  const {flagsRegistry: registry} = useContext(RegistriesContext);

  return useX(registry, flags, defaultFlag, name);
}
